import React,{useEffect, useState} from 'react';
import './Header.css'
import { Container,Offcanvas } from 'react-bootstrap';
import { MdModeNight} from 'react-icons/md';
import { IoSunnySharp} from 'react-icons/io5';

import { AiOutlineMenu } from 'react-icons/ai';
const Header = (props) => {
    useEffect(()=>{
        const Color =getComputedStyle(document.documentElement).getPropertyValue('--color') 
        const Bg =getComputedStyle(document.documentElement).getPropertyValue('--background') 
    },[])
    const [show, setShow] = useState(false);
    const [changebg, setChangebg] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const ChangeBg=(color,BgColor,e)=>{
        e.preventDefault();
        document.documentElement.style.setProperty('--color',color)
        document.documentElement.style.setProperty('--background',BgColor)
        setChangebg(!changebg)
    }
   
    return (
        <div className='header-li'>

        <ul>
            <li>
                <a href='#home'>
                    Home
                </a>
            </li>
            <li>
                <a href='#my-work'>
                    My Work
                </a>
            </li>
            <li>
                <a href='#skills'>
                    Skills
                </a>
            </li>
            
            <li>
                <a href='#qualification'>
                    Qualification
                </a>
            </li>
            <li>
                <a href='#contact'>
                    Contact
                </a>
            </li>
            <li>
                <a onClick={(e)=>ChangeBg(changebg ? "black":"#ebebeb",changebg ? "#ebebeb":"black",e)} className='change-bg' >
                    {changebg ? <IoSunnySharp />:<MdModeNight />}
                </a>
            </li>
        </ul>
                   <AiOutlineMenu onClick={handleShow} className='menu-icon' />
        

      <Offcanvas className='responsive-nav' show={show} onHide={handleClose} placement='end' >
        <Offcanvas.Header closeButton>
        </Offcanvas.Header>
        <Offcanvas.Body >
        <ul>
            <li>
                <a href='#home'  onClick={handleClose}>
                    Home
                </a>
            </li>
            <li>
                <a href='#skills' onClick={handleClose}>
                    Skills
                </a>
            </li>
           
            <li>
                <a href='#qualification' onClick={handleClose}>
                    Qualification
                </a>
            </li>
            
            <li>
                <a href='#contact' onClick={handleClose}>
                    Contact
                </a>
            </li>
            
        </ul>
         
        </Offcanvas.Body>
      </Offcanvas>

        </div>
    );
}

export default Header;